import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, { EndpointQueryParameters, StrapiUpdate } from '../../types/strapi/strapi'
import { StrapiSingle } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import Tube from '../../types/api/tube'

export const tubesApi = createApi({
    reducerPath: 'tubesApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Tubes'],
    endpoints: builder => ({
        getTubes: builder.query<Strapi<Tube>, EndpointQueryParameters | void>({
            query: getQuery('/tubes'),
            providesTags: ['Tubes'],
        }),
        getTubesByDocId: builder.query<
            StrapiSingle<Tube>,
            [string, EndpointQueryParameters] | [string]
        >({
            query: ([docId, params]) => getQuery(`/tubes/${docId}`)(params),
        }),
        updateTube: builder.mutation<StrapiSingle<Tube>, StrapiUpdate<Tube>>({
            query: ({ docId, body }) => ({
                url: `/tubes/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Tubes'],
        }),
    }),
})

export const {
    useGetTubesQuery,
    useLazyGetTubesQuery,
    useGetTubesByDocIdQuery,
    useUpdateTubeMutation,
} = tubesApi
